import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { postUserVisit } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import { isEmpty, isUndefined } from "lodash";
import { useContext, useEffect } from "react";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getLoggedInUserDetails } from "utils/CommonFunctions";
import { commonApiCallParam, updatePopupHeader } from "utils/UserAnalyticsUtils";
import CloseButton from "./CloseButton";
import "./DialogFormation.scss";
import Typography from "./Typography";

interface Prop {
  openDialog: boolean;
  handleClose: () => void;
  title?: string;
  children?: React.ReactNode;
  actionConfig?: React.ReactNode;
  parentOverflow?: boolean;
  contentClass?: string;
  isCrossShow?: boolean;
  subTitle?: string | React.ReactNode;
  closeButtonClass?: string;
  isFullscreen?: boolean;
  parentClass?: string;
  preventPageApi?: boolean;
  subHeading?: string;
  modifyParam?: (param: any) => any;
}

export default function DialogFormation(props: Prop) {
  const { isMobileScreen } = useContext(ThemeContext);
  const dispatch = useAppDispatch();

  const {
    openDialog,
    handleClose,
    title,
    actionConfig,
    children,
    contentClass = "",
    isCrossShow = true,
    subTitle = "",
    closeButtonClass = "",
    isFullscreen = false,
    parentClass = "",
    modifyParam
  } = props;

  useEffect(() => {
    if (openDialog && !props.preventPageApi) {
      const userDetails = getLoggedInUserDetails();
      if (!isEmpty(userDetails)) {
        const params = commonApiCallParam(true, undefined);
        const newHeading = title || props.subHeading || "";
        const updatedparam = updatePopupHeader(newHeading);
        params.popupHeader = updatedparam;
        const newParam = !isUndefined(modifyParam) ? modifyParam(params) : params;
        dispatch(postUserVisit(newParam));
      }
    }
  }, [getLoggedInUserDetails, openDialog, props.preventPageApi]);

  return (
    <Dialog
      fullWidth={true}
      className={`dialogFormation-component ${parentClass}`}
      fullScreen={isMobileScreen || isFullscreen}
      open={openDialog}
      onClose={(e, r) => {
        if (r !== "backdropClick") handleClose();
      }}
    >
      {title ? (
        <DialogTitle className="dialog-title">
          <div className="title-wrapper">
            <div>
              <Typography color={tokens.Text.General.PrimaryHeadline} showBold variant="h5">
                {title}
              </Typography>
              {subTitle && (
                <Typography color={tokens.Text.General.PrimaryBody} variant="body2" className="subtitle">
                  {subTitle}
                </Typography>
              )}
            </div>
            {isCrossShow && (
              <div className={closeButtonClass}>
                <CloseButton handleClose={handleClose} />
              </div>
            )}
          </div>
        </DialogTitle>
      ) : (
        <div className="dialog-title-no-bg ">
          <CloseButton handleClose={handleClose} />
        </div>
      )}
      <DialogContent id="actionItemsDivMobile" className={`dialog-content-wrapper ${contentClass}`}>
        {children}
      </DialogContent>
      {actionConfig && <DialogActions className="dialog-actions">{actionConfig}</DialogActions>}
    </Dialog>
  );
}
